<template>
  <section class="panel fixed top-0 left-0 w-full h-full z-50 bg-[rgba(207,207,207,0.8)] flex items-center justify-center pointer-events-auto" @click.self="$emit('hide')">
    <div class="md:w-3/5 bg-white rounded-2xl m-5 shadow-lg">
      <button class="float-end p-4" @click="$emit('close')"><AtomIconCross /></button>
      <div class="panel-content p-8 lg:px-[80px] lg:py-[40px]">
        <MoleculeOverlayMatrix :items="items" :title="title" @close="$emit('close')" @hide="$emit('hide')" @newsletter-subscribed="$emit('newsletter-subscribed')" />
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
defineProps({
  items: { type: Array as PropType<any[]>, required: true },
  title: { type: String, required: false, default: '' },
})

defineEmits(['close', 'hide', 'newsletter-subscribed'])
</script>

<style scoped lang="scss"></style>
